
<ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
	<p style="color: white"> Loading... </p>
</ngx-spinner>

<div id="learning-center"> 
	<span [innerHTML]="data | noSanitizeHtml" class="learning-center"></span> 
</div>